// Choose your own password — the first thing a new team member does after
// signing in with the temporary one from their invite email.
import React, { useState } from 'react';
import { Eye, EyeOff, Lock, Check } from 'lucide-react';
import { inviteApi, passwordProblem } from '../../services/account';

const RULES = [
  ['At least 8 characters', (p) => p.length >= 8],
  ['An uppercase letter', (p) => /[A-Z]/.test(p)],
  ['A lowercase letter', (p) => /[a-z]/.test(p)],
  ['A number', (p) => /\d/.test(p)],
];

const SetPasswordForm = ({ onDone }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    const problem = passwordProblem(password);
    if (problem) return setError(problem);
    if (password !== confirm) return setError('The two passwords do not match');
    setSaving(true);
    try {
      await inviteApi.setPassword(password, confirm);
      onDone();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const input = 'w-full rounded-lg border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 pl-9 pr-10 py-2.5 text-sm text-gray-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500';

  return (
    <form onSubmit={submit} className="space-y-4">
      <div className="relative">
        <Lock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input className={input} type={show ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="New password" autoComplete="new-password" autoFocus />
        <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" aria-label={show ? 'Hide password' : 'Show password'}>
          {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
      <div className="relative">
        <Lock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input className={input} type={show ? 'text' : 'password'} value={confirm} onChange={(e) => setConfirm(e.target.value)}
          placeholder="Type it again" autoComplete="new-password" />
      </div>
      <ul className="grid grid-cols-2 gap-1">
        {RULES.map(([label, test]) => (
          <li key={label} className={`flex items-center gap-1.5 text-xs ${test(password) ? 'text-green-600 dark:text-green-400' : 'text-gray-400'}`}>
            <Check className="w-3.5 h-3.5" />{label}
          </li>
        ))}
      </ul>
      {error && <p className="text-sm text-red-600 dark:text-red-400">{error}</p>}
      <button type="submit" disabled={saving} className="w-full rounded-lg bg-blue-600 hover:bg-blue-700 text-white py-2.5 text-sm font-semibold disabled:opacity-60">
        {saving ? 'Saving…' : 'Save password and continue'}
      </button>
    </form>
  );
};

export default SetPasswordForm;
